/**
 * system 模块（系统管理）英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 * 术语约定：用户=User，角色=Role，部门=Department，菜单=Menu，字典=Dictionary，
 *          定时任务=Scheduled Job，日志=Log，权限=Permission
 */
export default {
  // ---- 通用 ----
  '共{total}条': 'Total {total} records',
  '保存': 'Save',
  '保存成功!': 'Saved successfully!',
  '名称': 'Name',
  '状态': 'Status',
  '描述': 'Description',
  '参数': 'Parameter',
  '版本号': 'Version',
  '排序': 'Sort Order',
  '地址': 'Address',
  '手机号': 'Mobile Phone',
  '传真': 'Fax',
  '账号': 'Account',
  '账户': 'Account',
  '用户名': 'Username',
  '无': 'None',
  '全部': 'All',
  '正常': 'Normal',
  '禁用': 'Disabled',
  '查看': 'View',
  '标题': 'Title',
  '授权': 'Authorize',
  '发布': 'Publish',
  '撤销': 'Revoke',
  '启动': 'Start',
  '停止': 'Stop',
  '冻结': 'Freeze',
  '解冻': 'Unfreeze',
  '退出': 'Logout',
  '登录': 'Sign In',
  '提示信息': 'Notice',
  '添加': 'Add',
  '导入': 'Import',
  '导出': 'Export',
  '添加下级': 'Add Child',
  '批量删除': 'Batch Delete',
  '新增用户': 'New Users',
  '新建角色': 'Add Role',
  '已有用户': 'Existing Users',
  '展开': 'Expand',
  '收起': 'Collapse',
  '展开所有': 'Expand All',
  '合并所有': 'Collapse All',
  '全部勾选': 'Check All',
  '取消全选': 'Uncheck All',
  '取消选择': 'Deselect',
  '父子关联': 'Parent-Child Link',
  '取消关联': 'Unlink',
  '树操作': 'Tree Actions',
  '当前选择：': 'Currently selected:',
  '刷新缓存': 'Refresh Cache',
  '清除缓存': 'Clear Cache',
  '回收站': 'Recycle Bin',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '更新时间': 'Updated At',
  '确认删除': 'Confirm Deletion',
  '确认提示': 'Confirm',
  '确认启动': 'Confirm Start',
  '确认暂停': 'Confirm Pause',
  '是否删除选中数据?': 'Delete the selected data?',
  '是否启动选中任务?': 'Start the selected job?',
  '是否暂停选中任务?': 'Pause the selected job?',
  '是否立即执行任务?': 'Execute the job immediately?',
  '删除成功!': 'Deleted successfully!',
  '删除失败!': 'Failed to delete!',
  '请选择一条记录！': 'Please select a record!',
  '请选择两条数据': 'Please select two records',
  '请选择一个角色!': 'Please select a role!',
  '请选择': 'Please select',
  '请选择开始时间': 'Please select start time',
  '请选择结束时间': 'Please select end time',
  '生成中...': 'Generating...',
  '生成结果：': 'Generated result: ',
  '未录入任何信息': 'No information entered',
  '彻底删除': 'Delete Permanently',
  '您确定要彻底删除这个字典项吗？': 'Are you sure you want to permanently delete this dictionary item?',
  '注意：彻底删除后将无法恢复，请谨慎操作！': 'Note: Data cannot be recovered after permanent deletion, please proceed with caution!',

  // ---- 账号异常 / 解绑冻结记录 ----
  '这是账号异常页面': 'This is the account exception page',
  '这是账号解绑及冻结记录页面': 'This is the account unbinding and freezing record page',
  '输入账号模糊查询': 'Enter account to search',
  '请选择异常类型': 'Please select abnormal type',
  '异常账户': 'Abnormal Account',
  '异常类型': 'Abnormal Type',
  '异常客户端操作系统': 'Abnormal Client OS',
  '异常ip': 'Abnormal IP',
  '异常描述': 'Abnormal Description',
  '异常城市': 'Abnormal City',
  '地区码': 'Region Code',
  '异常浏览器': 'Abnormal Browser',
  '未读': 'Unread',
  '已读': 'Read',
  '用户真实姓名': 'User Real Name',
  '操作类型': 'Operation Type',
  '操作时间': 'Operation Time',
  '操作员账号': 'Operator Account',
  '操作员真实姓名': 'Operator Real Name',
  '操作描述': 'Operation Description',

  // ---- 数据日志 ----
  '数据日志管理页面': 'Data Log Management Page',
  '表名': 'Table Name',
  '请输入表名': 'Please enter table name',
  '数据ID': 'Data ID',
  '请输入ID': 'Please enter ID',
  '数据内容': 'Data Content',
  '数据比较': 'Data Comparison',
  '请选择相同的数据库表和数据ID进行比较': 'Please select records with the same database table and data ID for comparison',

  // ---- 部门 ----
  '通讯录页面': 'Contacts Page',
  '请输入部门名称': 'Please enter department name',
  '上级部门': 'Parent Department',
  '部门名称': 'Department Name',
  '部门编码': 'Department Code',
  '部门类型': 'Department Type',
  '部门权限': 'Department Permissions',
  '部门角色': 'Department Roles',
  '部门': 'Department',
  '公司': 'Company',
  '岗位': 'Post',
  '安全信息': 'Security Info',
  '常用城市': 'Common City',
  '常用ip': 'Common IP',
  '工作开始时间': 'Work Start Time',
  '工作结束时间': 'Work End Time',
  '请输入手机号': 'Please enter mobile phone number',
  '请输入地址': 'Please enter address',
  '请输入机构编码': 'Please enter organization code',
  '请选择机构类型': 'Please select organization type',
  '请输入常用城市': 'Please enter common city',
  '请输入常用ip/(格式为xxxx,xxxx,xxxx;多个以逗号隔开)': 'Please enter common IP (format: xxxx,xxxx,xxxx; separate multiple with commas)',
  '请选择工作开始时间': 'Please select work start time',
  '请输入部门编码': 'Please enter department code',
  '您的部门下暂无有效部门信息': 'No valid department information under your department',
  '普通员工无暂此权限': 'Regular employees do not have this permission',
  '用户信息': 'Customer Info',
  '机构名称': 'Organization Name',
  '机构类型': 'Organization Type',
  '机构编码': 'Organization Code',
  '请输入机构/部门名称!': 'Please enter the organization/department name!',
  '请输入机构编码!': 'Please enter the organization code!',
  '请输入机构类型!': 'Please enter the organization type!',
  '请先选择一个部门!': 'Please select a department first!',
  '请点击选择要修改部门!': 'Please click to select the department to modify!',
  '请先点击选中上级部门！': 'Please select a parent department first!',
  '确定要删除所选中的 {count} 条数据，以及子节点数据吗?': 'Are you sure to delete the selected {count} records and their child nodes?',
  '确定要删除此部门以及子节点数据吗?': 'Are you sure to delete this department and its child nodes?',

  // ---- 字典 ----
  '这是数据字典页面': 'This is the data dictionary page',
  '字典名称': 'Dictionary Name',
  '字典编号': 'Dictionary Code',
  '字典信息': 'Dictionary Info',
  '字典列表': 'Dictionary List',
  '字典取回': 'Restore Dictionary',
  '字典配置': 'Dictionary Config',
  '彻底删除字典': 'Delete Dictionary Permanently',
  '数据值': 'Data Value',
  '请输入字典名称': 'Please enter dictionary name',
  '请输入字典编号': 'Please enter dictionary code',
  '请输入名称': 'Please enter name',
  '请输入名称!': 'Please enter the name!',
  '请输入名称查询': 'Enter name to search',
  '请输入数据值!': 'Please enter the data value!',

  // ---- 文件管理 ----
  '这是文件管理页面': 'This is the file management page',
  '文件名称': 'File Name',
  '文件描述': 'File Description',
  '输入文件名称模糊查询': 'Enter file name to search',

  // ---- 日志 ----
  '这是日志管理页面': 'This is the log management page',
  '用户登录记录': 'User Login Records',
  '系统操作日志': 'System Operation Logs',
  '营收模块日志': 'Revenue Module Log',
  '工单模块日志': 'Work Order Module Log',
  'OA模块日志': 'OA Module Log',
  '搜索日志': 'Search Log',
  '请输入账户模糊查询': 'Enter account to search',
  '请输入搜索关键词': 'Please enter a search keyword',
  '登录类型': 'Login Type',
  '请选择登录类型': 'Please select login type',
  '登录账户': 'Login Account',
  '登录用户真实名称': 'Login User Real Name',
  '登录客户端操作系统': 'Login Client OS',
  '登录ip': 'Login IP',
  '登录城市': 'Login City',
  '登录浏览器': 'Login Browser',
  '请求方法:': 'Request Method:',
  '请求参数:': 'Request Params:',
  '日志内容': 'Log Content',
  '日志类型': 'Log Type',
  '操作人ID': 'Operator ID',
  '操作人名称': 'Operator Name',
  '耗时(毫秒)': 'Elapsed Time (ms)',

  // ---- 菜单/权限 ----
  '这是菜单管理页面': 'This is the menu management page',
  '菜单名称': 'Menu Name',
  '菜单类型': 'Menu Type',
  '菜单': 'Menu',
  '按钮/权限': 'Button/Permission',
  '组件': 'Component',
  '路径': 'Path',
  '数据规则': 'Data Rule',
  '数据权限规则': 'Data Permission Rule',
  '添加子菜单': 'Add Sub-menu',
  '规则名称': 'Rule Name',
  '规则Code': 'Rule Code',
  '规则值': 'Rule Value',
  '规则字段': 'Rule Field',
  '规则描述': 'Rule Description',
  '请输入规则名称': 'Please enter rule name',
  '请输入规则Code': 'Please enter rule code',
  '请输入规则值': 'Please enter rule value',

  // ---- 定时任务 ----
  '定时任务信息': 'Scheduled Job Info',
  '定时任务在线管理': 'Online Scheduled Job Management',
  '定时任务在线管理new': 'Online Scheduled Job Management (New)',
  '任务类名': 'Job Class Name',
  '任务状态': 'Job Status',
  'cron表达式': 'Cron Expression',
  '立即执行': 'Execute Now',
  '执行一次': 'Run Once',
  '已启动': 'Started',
  '已暂停': 'Paused',
  '请输入任务类名': 'Please enter job class name',
  '请选择状态': 'Select status',

  // ---- 角色 ----
  '角色信息': 'Role Info',
  '角色名称': 'Role Name',
  '角色编码': 'Role Code',
  '角色管理': 'Role Management',
  '角色管理页面': 'Role Management Page',
  '用户': 'User',
  '用户账号': 'User Account',
  '用户名称': 'Customer Name',
  '该角色已有绑定用户，暂不能删除!': 'This role already has bound users and cannot be deleted!',
  '请设置url.list2属性!': 'Please set the url.list2 property!',
  '请设置url.delete2属性!': 'Please set the url.delete2 property!',
  '请设置url.deleteBatch2属性!': 'Please set the url.deleteBatch2 property!',

  // ---- 系统通告 ----
  '系统通告': 'System Announcement',
  '系统通告表管理页面': 'System Announcement Management Page',
  '请输入标题': 'Please enter the title',
  '消息类型': 'Message Type',
  '通知公告': 'Notice & Announcement',
  '系统消息': 'System Message',
  '发布人': 'Publisher',
  '优先级': 'Priority',
  '低': 'Low',
  '中': 'Medium',
  '高': 'High',
  '通告对象': 'Announcement Target',
  '指定用户': 'Specified Users',
  '全体用户': 'All Users',
  '发布状态': 'Publish Status',
  '未发布': 'Unpublished',
  '已发布': 'Published',
  '已撤销': 'Revoked',
  '发布时间': 'Publish Time',
  '撤销时间': 'Revoke Time',
  '确定发布吗?': 'Are you sure to publish?',
  '确定撤销吗?': 'Are you sure to revoke?',

  // ---- 分类字典 ----
  '分类字典': 'Category Dictionary',
  '分类字典管理页面': 'Category Dictionary Management Page',
  '分类名称': 'Category Name',
  '分类编码': 'Category Code',
  '添加子分类': 'Add Subcategory',

  // ---- 编码校验规则 ----
  '编码校验规则': 'Code Validation Rule',
  '编码校验规则管理页面': 'Code Validation Rule Management Page',
  '功能测试': 'Function Test',

  // ---- 多数据源 ----
  '多数据源管理': 'Multi-Data Source Management',
  '多数据源管理管理页面': 'Multi-Data Source Management Page',
  '数据源名称': 'Data Source Name',
  '数据源编码': 'Data Source Code',
  '数据源地址': 'Data Source URL',
  '数据库类型': 'Database Type',
  '数据库名称': 'Database Name',
  '驱动类': 'Driver Class',
  '请输入数据源名称': 'Please enter data source name',
  '请选择数据库类型': 'Please select database type',

  // ---- 填值规则 ----
  '填值规则': 'Fill Rule',
  '填值规则管理页面': 'Fill Rule Management Page',
  '填值规则功能测试': 'Fill Rule Function Test',
  '规则实现类': 'Rule Implementation Class',
  '规则参数': 'Rule Parameter',

  // ---- 网关路由 ----
  'gateway路由管理管理页面': 'Gateway Route Management Page',
  '路由配置请慎重': 'Please be careful with route configuration',

  // ---- 职务 ----
  '职务表': 'Position',
  '职务表管理页面': 'Position Management Page',
  '职务名称': 'Position Name',
  '职务编码': 'Position Code',
  '职级': 'Position Rank',
  '请输入职务名称': 'Please enter position name',
  '请输入职务编码': 'Please enter position code',
  '请选择职级': 'Please select position rank',

  // ---- jeecg 生成页面 ----
  'jeecg 生成SysDepart代码管理页面': 'SysDepart Management Page (generated by jeecg)',

  // ---- 系统账号（与用水客户区分） ----
  '账号名称': 'Account Name',
  '账号姓名': 'Account Holder Name',
  '账号状态': 'Account Status',
  '账号列表': 'Account List',
  '账号详情': 'Account Details',
  '账号信息': 'Account Information',
  '新增账号': 'Add Account',
  '新建账号': 'Add Account',
  '编辑账号': 'Edit Account',
  '选择账号': 'Select Account',
  '已有账号': 'Existing Accounts',
  '冻结账号': 'Freeze Account',
  '解冻账号': 'Unfreeze Account',
  '账号回收站': 'Account Recycle Bin',
  '授权账号': 'Authorize Accounts',
  '登录账号': 'Login Account',
  '请输入登录账号': 'Please enter the login account',
  '请输入登录账号!': 'Please enter the login account!',
  '请输入账号名称': 'Please enter the account name',
  '请输入账号名称!': 'Please enter the account name!',
  '请输入账号姓名': 'Please enter the account holder name',
  '添加账号': 'Add Account',
  '添加已有账号': 'Add Existing Account',
  '账号代理人设置': 'Account Agent Settings',
  '请选择账号角色': 'Please select an account role',
  '普通账号': 'Normal Account',
  '还原账号': 'Restore Account',
  '恢复账号': 'Recover Account',
  '彻底删除账号': 'Permanently Delete Account',
  '账号名不能包含中文！': 'Account name cannot contain Chinese characters!',
  '账号名已存在!': 'Account name already exists!',
  '该账号已被巡检关联，是否删除该账号？': 'This account is associated with inspections. Delete it anyway?',
  '该角色已有绑定账号，暂不能删除!': 'This role has bound accounts and cannot be deleted!',
  '未选中任何部门，无法取消部门与账号的关联!': 'No department selected, cannot unlink the department from the account!',
  '是否取消账号与选中部门的关联?': 'Unlink the account from the selected department?',
  '删除账号与选中部门关系成功！': 'Account and department unlinked successfully',
  '查询已删除的账号失败：': 'Failed to query deleted accounts: ',
  '您确定要恢复这 {count} 个账号吗？': 'Are you sure you want to restore these {count} accounts?',
  '还原 {count} 个账号成功！': 'Restored {count} accounts successfully!',
  '您确定要彻底删除这 {count} 个账号吗？': 'Are you sure you want to permanently delete these {count} accounts?',
  '彻底删除 {count} 个账号成功！': 'Permanently deleted {count} accounts successfully!'
}
